module.exports = __webpack_public_path__ + "img/LMI_GoToWebinar_Blue_HEX.2dbe4098.png";